import { render, staticRenderFns } from "./ChannelPartner.vue?vue&type=template&id=b8f47e1c&"
import script from "./ChannelPartner.vue?vue&type=script&lang=js&"
export * from "./ChannelPartner.vue?vue&type=script&lang=js&"
import style0 from "./ChannelPartner.vue?vue&type=style&index=0&id=b8f47e1c&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports